import React, { useState } from "react";

import TimezoneSelect from "../components/TimezoneSelect";
import type { SettingsPageProps } from "./OrgActions";

const TimezoneCard: React.FC<SettingsPageProps> = ({ data, busy, run, actions }) => {
  const [tz, setTz] = useState(data.org.timezone || "");
  return (
    <div className="dg-card">
      <div className="dg-card-head">
        <div className="dg-card-title">Organisation timezone</div>
        <button
          className="dg-btn dg-btn-primary dg-btn-sm"
          disabled={busy || tz === (data.org.timezone || "")}
          onClick={() => run(() => actions.setTimezone(tz))}
        >
          Save
        </button>
      </div>
      <div className="dg-card-body">
        <div className="dg-field">
          <label>Timezone</label>
          <TimezoneSelect aria-label="Timezone" value={tz} onChange={setTz} />
        </div>
      </div>
    </div>
  );
};

export default TimezoneCard;
